import React, { useState } from 'react';
import { login } from '../services/api';

function Login({ onLogin, onRequestAccess, onForgotPassword, onSignupOrganizer, siteBranding }) {
    const [email,    setEmail]    = useState('');
    const [password, setPassword] = useState('');
    const [error,    setError]    = useState('');
    const [loading,  setLoading]  = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const res = await login(email, password);
            // PR-JWT-COOKIE: no token in body; the cookie was set by the
            // login response's Set-Cookie header. Just propagate the
            // participant to App state.
            onLogin(res.data.participant);
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#13294f] flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    {siteBranding ? (
                        <div className="flex items-center justify-center gap-3 mb-4">
                            <img src="/favicon.svg" alt="" className="h-12 w-12 flex-shrink-0" />
                            <div className="text-left leading-tight">
                                <div className="text-3xl font-black text-orange-400 tracking-tight">
                                    {siteBranding.display_name}
                                </div>
                                <div className="text-xs text-gray-500 tracking-wide">
                                    Powered by HebertHoops.com
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="flex items-center justify-center gap-3 mb-4">
                            <img src="/favicon.svg" alt="HebertHoops" className="h-12 w-12 flex-shrink-0" />
                            <div className="text-left leading-tight">
                                <div className="text-3xl font-black text-white tracking-tight">
                                    Hebert<span className="text-orange-500">Hoops</span>
                                </div>
                            </div>
                        </div>
                    )}
                    <p className="text-gray-400">Sign in to view your bracket</p>
                </div>
                <div className="bg-gray-900 rounded-2xl p-8 border border-gray-800">
                    {error && (
                        <div className="bg-red-900/50 border border-red-500 text-red-300 px-4 py-3 rounded-lg mb-6 text-sm">
                            {error}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">
                                Email
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-orange-500 transition-colors"
                                placeholder="you@example.com"
                                autoCorrect="off"
                                autoCapitalize="none"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">
                                Password
                            </label>
                            <input
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-orange-500 transition-colors"
                                placeholder="••••••••"
                                autoCorrect="off"
                                autoCapitalize="none"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-orange-900 text-white font-bold py-3 rounded-lg transition-colors"
                        >
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>
                    {onForgotPassword && (
                        <div className="text-center mt-4">
                            <button
                                onClick={onForgotPassword}
                                className="text-gray-400 hover:text-gray-300 text-sm font-medium"
                            >
                                Forgot password?
                            </button>
                        </div>
                    )}
                    {onRequestAccess && (
                        <div className="text-center mt-6 pt-6 border-t border-gray-800">
                            <span className="text-gray-400 text-sm">Don't have an account? </span>
                            <button
                                onClick={onRequestAccess}
                                className="text-orange-400 hover:text-orange-300 text-sm font-medium"
                            >
                                Request access
                            </button>
                        </div>
                    )}
                    {onSignupOrganizer && (
                        <div className="text-center mt-4 pt-4 border-t border-gray-800">
                            <button
                                onClick={onSignupOrganizer}
                                className="text-orange-500 hover:text-orange-400 text-sm font-bold"
                            >
                                Run your own pool →
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Login;